module.exports = __webpack_public_path__ + "static/01-032a29c14bf4d2f3c1312fd8332f3abb.jpg";